import { render, staticRenderFns } from "./ServiceAnamnezLayout.vue?vue&type=template&id=48e9a93d&scoped=true"
import script from "./ServiceAnamnezLayout.vue?vue&type=script&lang=ts"
export * from "./ServiceAnamnezLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9a93d",
  null
  
)

export default component.exports